var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm._.block},[_c('div',{class:[_vm._.title, _vm._._hairlineBottom]},[_vm._v("组合内包含商品")]),_c('JointSubGoods',{class:_vm._.content,attrs:{"value":_vm.jointGoodsModel.childList,"clickable":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }